import { render, staticRenderFns } from "./VCA_Internals.vue?vue&type=template&id=1b63d098&scoped=true&"
import script from "./VCA_Internals.vue?vue&type=script&lang=ts&"
export * from "./VCA_Internals.vue?vue&type=script&lang=ts&"
import style0 from "./VCA_Internals.vue?vue&type=style&index=0&id=1b63d098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63d098",
  null
  
)

export default component.exports